var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.referenceName,staticClass:"smart-captcha",attrs:{"id":"captcha-container","data-sitekey":_vm.apiToken}})
}
var staticRenderFns = []

export { render, staticRenderFns }